<div *ngIf="loader.getMode() === 'block'" class="cssload-container">
    <div class="cssload-speeding-wheel"></div>
</div>
<div *ngIf="loader.getMode() === 'bar'" class="cssload-bar" aria-hidden="true"></div>